import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div`
  display: flex;
`;

const PcBox = styled(DefaultBox)`
  align-items: center;
`;

const Mobilebox = styled(DefaultBox)`
  width: 100%;
  padding: 0.5rem 0 0 0;
  justify-content: center;

  .cgp-dk & {
    //justify-content: flex-start;
  }
`;

export const ResponsibleGamingIconsDefaultBox = styledByDevice(PcBox, Mobilebox);
